export default __webpack_public_path__ + "static/media/09_odvetvovani.4008631f.jpg";